import React, { useEffect, useState } from 'react';
import logo from '../../../images/logo.svg';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { casheaService } from '../../../services/CasheaService';
import { notify } from '../../../assets/helpers/toast';

const CasheaCheckout = () => {
  const location = useLocation();
  const [countdown, setCountdown] = useState(0);
  const [hasCountdownStarted, setHasCountdownStarted] = useState(false);
  const [showCountdown, setShowCountdown] = useState(false);
  const [membershipInfo, setMembershipInfo] = useState({});

  const validateOrderInfo = async id => {
    casheaService
      .getOrder(id)
      .then(response => {
        if (response.status === 200) {
          setMembershipInfo(prevState => ({
            ...prevState,
            casheaParentOrderId: response?.data?.order?.idNumber,
            casheaOrderId:
              response?.data?.order?.orderDetails?.orders?.[0]?.idNumber,
            casheaDownPayment: response?.data?.order?.orderDetails?.downPayment,
          }));
        } else {
          notify('Ha ocurrido un error al intentar procesar su orden', 'error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const paramsObject = {};

    for (const [key, value] of queryParams.entries()) {
      paramsObject[key] = value;
    }
    validateOrderInfo(paramsObject.idNumber);
  }, [location.search]);

  useEffect(() => {
    let timer;
    let closeTimeout;

    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else if (countdown === 0 && hasCountdownStarted) {
      closeTimeout = setTimeout(() => {
        if (window.opener) {
          // window.opener.postMessage(
          //   { type: 'popupClosed', data: membershipInfo },
          //   window.location.origin
          // );
          window.close();
        } else {
        }
      }, 500);
      return () => clearTimeout(closeTimeout);
    }

    return () => {
      if (timer) clearInterval(timer);
      if (closeTimeout) clearTimeout(closeTimeout);
    };
  }, [countdown, hasCountdownStarted]);

  const startCountdown = () => {
    localStorage.setItem('casheaResult', JSON.stringify(membershipInfo));
    if (countdown === 0) {
      setShowCountdown(true);
      setCountdown(2);
      setHasCountdownStarted(true);
    }
  };

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        backgroundColor: '#fefefe',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        flexDirection: 'column',
        // fontFamily: 'sans-serif',
        fontWeight: 'bold',
      }}
    >
      <img src={logo} alt="logo" className="landing-logo" />

      <h2>¡YA CASI FINALIZAMOS!</h2>
      {membershipInfo && (
        <div>
          <h6>Presiona para pagar la inicial de tu plan</h6>

          {showCountdown ? (
            <p>
              Volverás a TU/GRUERO en:{' '}
              {<span style={{ fontWeight: 'bold' }}>{countdown}</span>} segundos
            </p>
          ) : (
            <div
              style={{
                marginTop: '20px',
                color: '#fefefe',
                background: '#F27730',
                border: '1px solid #F27730',
                padding: '10px',
                fontSize: '18px',
                borderRadius: '12px',
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
              onClick={startCountdown}
            >
              Pagar mi inicial
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CasheaCheckout;
